import { Container, Grid, Typography } from "@pmberjaya/cloudbank-ui";
import React from "react";
import Image from "next/image";
import { CheckBoxIcon } from "../../Common/Icon";
import Section from "../../Common/Section";
const listStep = [
  {
    title: "HARGA TERMURAH",
    description:
      "Mulai kesuksesan online Anda dengan modal bisnis minimal! Dapatkan harga jual yang bahkan lebih murah dari layanan Cloudbank. Hal ini berlaku untuk order baru dan perpanjangannya",
  },
  {
    title: "MARK UP HARGA",
    description:
      "Beri nama paket hosting yang anda gunakan dan tentukan sendiri harga untuk para pelanggan menggunakan fitur markup harga. Anda dapat mengambil keuntungan tanpa batas sesuai kebutuhan",
  },
  {
    title: "WHITE LABEL",
    description:
      "Tampilkan identitas bisnis Anda dengan memberikan client area yang terintegrasi untuk mengelola order dan tagihan dari sistem. Fitur ini membuat Anda seakan-akan memiliki layanan hosting sendiri",
  },
  {
    title: "TANPA DEPOSIT & BIAYA BULANAN",
    description:
      "Cloudbank reseller hadir tanpa deposit maupun biaya langganan bulanan. Anda tidak perlu mengeluarkan cost untuk order yang tidak diperlukan. Tidak perlu boros lagi, pilih dan bayar order hosting sesuai dengan penggunaan client",
  },
  {
    title: "DUKUNGAN LAYANAN KHUSUS",
    description:
      "Dengan bergabung di Cloudbank reseller, Anda akan mendapatkan harga khusus, prioritas admin dan berbagai kemudahan lain untuk mengelola website client Anda",
  },
];
const WhyJoinReseller = () => {
  return (
    <Section>
      <Typography
        variant="h2"
        alignText="center"
        className="text-heading-h2"
        textTransform="uppercase"
      >
        Kenapa harus bergabung dengan Cloudbank Reseller
      </Typography>
      <Grid row alignSelf="center" alignItems="center">
        <Grid md={6}>
          <Image
            alt="reseller"
            src="/image/resellerillustration.svg"
            width={1000}
            height={1000}
          />
        </Grid>
        <Grid md={6}>
          {listStep.map((row) => (
            <>
              <Grid className="d-flex" xs={12}>
                <CheckBoxIcon />

                <Typography ms={3} className="text-heading-h4">
                  {row.title}
                </Typography>
              </Grid>
              <Grid>
                <Typography className="text-paragraf ps-5">
                  {row.description}
                </Typography>
              </Grid>
            </>
          ))}
        </Grid>
      </Grid>
    </Section>
  );
};

export default WhyJoinReseller;
